import { render, staticRenderFns } from "./pop-set-realname.vue?vue&type=template&id=50a46632&scoped=true"
import script from "./pop-set-realname.vue?vue&type=script&lang=js"
export * from "./pop-set-realname.vue?vue&type=script&lang=js"
import style0 from "./pop-set-realname.vue?vue&type=style&index=0&id=50a46632&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a46632",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\privateItem\\sct-shop\\sct-shop-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50a46632')) {
      api.createRecord('50a46632', component.options)
    } else {
      api.reload('50a46632', component.options)
    }
    module.hot.accept("./pop-set-realname.vue?vue&type=template&id=50a46632&scoped=true", function () {
      api.rerender('50a46632', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/components/pop-set-realname.vue"
export default component.exports